import { supabase } from "@/integrations/supabase/client";

/**
 * Enqueue a library item for re-embedding via the durable embed_queue.
 * Fire-and-forget at the call site, but the backing RPC writes to a
 * durable queue with retry + backoff (drain-embed-queue). The previous
 * implementation invoked `generate-embedding` directly — which had no
 * retry, no backoff, and silently dropped failures.
 */
export function triggerEmbedding(itemId: string, itemType: string): void {
  // Normalize frontend types to backend types
  const typeMap: Record<string, string> = {
    'qa': 'qa',
    'company-content': 'company_section',
    'case-study': 'case_study',
    'team': 'team_member',
    'document': 'document',
    // Already normalized forms
    'company_section': 'company_section',
    'case_study': 'case_study',
    'team_member': 'team_member',
    'pricing_template': 'pricing_template',
  };

  const normalizedType = typeMap[itemType] || itemType;

  supabase
    .rpc('enqueue_embedding_item', { p_item_id: itemId, p_item_type: normalizedType })
    .then(({ error }) => {
      if (error) console.warn('[triggerEmbedding] enqueue failed:', error.message);
    });
}

/**
 * Trigger embeddings for multiple items at once (e.g., bulk import).
 */
export function triggerEmbeddingBatch(items: Array<{ id: string; type: string }>): void {
  for (const item of items) {
    triggerEmbedding(item.id, item.type);
  }
}
